module.exports = __webpack_public_path__ + "img/btb.96ab034f.png";